import Naver, { EfProductNaverProps, EfProductNaverItemProps } from '@elem/ui/ef-product-naver';
import { useState } from 'react';
import Overview from './tabs/Overview';
import { theme } from './config/page';
import Support from './tabs/Support';
import css from './index.module.scss';
import getProductMsg from './context/getProduct';
import { IPageStatus } from './config/IPageStatus';
import { useProduct, useProductPageStatus } from './ProductProvider';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

const RapidPro: React.FC = () => {
    const { state, dispatch } = useProduct();
    const { locale } = getLocal();
    const { t } = useLang('rapidpro');
    const { productMsg, productSupport, activeTab } = state;
    const [activetedTabs, setActivetedTabs] = useState<string[]>([activeTab]);
    const pageStatus = useProductPageStatus();

    const naverProps: EfProductNaverProps = {
        theme: 'black',
        title: t('naver_title'), // 产品要求写死，因为是产品系列
        // title: productMsg?.name || t('naver_title'),
        tabs: [
            {
                key: 'Product',
                text: t('naver_tab_product'),
            },
            ['us', 'ca'].includes(locale) &&
                pageStatus === IPageStatus.LAUNCH && {
                    key: 'Beneft',
                    text: t('naver_tab_beneft'),
                },
            {
                key: 'Support',
                text: t('naver_tab_support'),
            },
            {
                key: 'Spec',
                text: t('naver_tab_spec'),
            },
        ].filter(Boolean),
        buyItem: {
            key: 'Buy',
            text: t('naver_tab_buy'),
        },
        hideClickFnTabs: ['Spec', 'Beneft'],
        activeTab,
        callbackBuy: () => {
            // 返回产品页，并定位
            dispatch({
                type: 'changeProductTab',
                payload: 'Product',
            });
            setTimeout(() => {
                const target: HTMLDivElement | null = document.querySelector('#rapid-pro-C');
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            }, 10);
        },
        callbackTab: (tab: EfProductNaverItemProps) => {
            if (tab.key !== activeTab && !['Beneft', 'Spec'].includes(tab.key)) {
                if (!activetedTabs.includes(tab.key)) {
                    setActivetedTabs([...activetedTabs, tab.key]);
                }
                dispatch({
                    type: 'changeProductTab',
                    payload: tab.key,
                });
            }
            if (tab.key === 'Spec') {
                if (activeTab !== 'Product') {
                    dispatch({
                        type: 'changeProductTab',
                        payload: 'Product',
                    });
                }
                setTimeout(() => {
                    const target: HTMLDivElement | null = document.querySelector('#rapid-pro-M');
                    if (target) {
                        target.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 10);
            } else if (tab.key === 'Beneft') {
                if (activeTab !== 'Product') {
                    dispatch({
                        type: 'changeProductTab',
                        payload: 'Product',
                    });
                }
                setTimeout(() => {
                    const target: HTMLDivElement | null = document.querySelector('#rapid-pro-B');
                    if (target) {
                        target.scrollIntoView({ behavior: 'smooth' });
                    }
                }, 10);
            }
        },
    };

    return (
        <>
            {!productMsg && getProductMsg()}
            <div className={`rapid-pro ${css.section}`} style={{ background: 'theme', minHeight: '100vh' }}>
                <Naver {...naverProps} />
                {activetedTabs.includes('Product') && (
                    <div className="page-tab tab-overview" style={{ display: activeTab === 'Product' ? 'block' : 'none' }}>
                        <Overview />
                    </div>
                )}
                {activetedTabs.includes('Support') && (
                    <div className="page-tab tab-support" style={{ display: activeTab === 'Support' ? 'block' : 'none' }}>
                        <Support supportData={productSupport} productMsg={productMsg} theme={theme} />
                    </div>
                )}
            </div>
        </>
    );
};

export default RapidPro;
